import { render } from "./ServiceJobGroupsView.vue?vue&type=template&id=5bd78250&ts=true"
import script from "./ServiceJobGroupsView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobGroupsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__